import SharedFileUploaderModal from "Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./useFileUploaderModal";
import { usePurchaseOrders } from "../../../../../../usePurchaseOrders";

function FileUploaderModal() {
  const { display, closeModal } = useFileUploaderModal();

  const uploadPath = `${process.env.REACT_APP_API}/api/upload`;

  return (
    <SharedFileUploaderModal
      display={display}
      onClose={closeModal}
      uploadPath={uploadPath}
      onUploaded={(data) => usePurchaseOrders.getState().attachFiles(data)}
    />
  );
}

export default FileUploaderModal;
